// extracted by mini-css-extract-plugin
export default {"SetsForm":"SetsForm---kgRIL","SetsFormContent":"SetsFormContent---q3rFS"};